import config from '#config';
import axios, { type AxiosResponse } from 'axios';

export const client = axios.create({
  baseURL: config.API,
  headers: {
    'Content-Type': 'application/json',
    'x-id': 'scannero-front',
    brand: config.BRAND,
  },
  withCredentials: true,
});

export const deaxiosify = <T>(response: AxiosResponse<T>) => response.data;
